"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Sidebar/List/GenericItem.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _user = require('shared/selectors/user');
var _entity = require('shared/services/entity');

var _Avatar = require('web/components/Avatar');
var _NameBadge = require('web/components/NameBadge'); var _NameBadge2 = _interopRequireDefault(_NameBadge);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);







const AVATAR_SIZE = 40

/* A Directory row, drawn as an inbox row: name and Admin tag over the
 * title, role or birth date. */
const ListItem = ({ entity, orgKey, isViewed }) => {
  if (!entity) return null
  const onOpen = () => _actions2.default.gotoEntityPage(entity, orgKey)
  const onKeyDown = (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return
    e.preventDefault()
    onOpen()
  }

  return (
    _react2.default.createElement('div', {
      role: "button",
      tabIndex: 0,
      onClick: onOpen,
      onKeyDown: onKeyDown,
      className: _classBuilder2.default.call(void 0, 'inbox-row', 'directory-row', isViewed && 'is-selected'),
      'aria-current': isViewed || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}

      , _react2.default.createElement(_Avatar.EntityAvatar, { entity: entity, size: AVATAR_SIZE, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}} )
      , _react2.default.createElement('div', { className: "inbox-row--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
        , _react2.default.createElement('div', { className: "inbox-row--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
          , _react2.default.createElement('span', { className: "inbox-row--name directory-row--name" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}},  entity.name )
          ,  _entity.isEntityUser.call(void 0, entity) &&
            _user.isUserAdminInOrg.call(void 0, entity.wrappedEntity, orgKey) && (
            _react2.default.createElement(_NameBadge2.default, { label: "Admin", className: "directory-tag", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}} )
          )
        )
        ,  entity.description && (
          _react2.default.createElement('div', { className: "inbox-row--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
            , _react2.default.createElement('span', { className: "inbox-row--preview directory-row--detail" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}},  entity.description )
          )
        )
      )
    )
  )
}

exports. default = ListItem
